import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, takeUntil, } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error';

import {
  LOAD,
  CLEAR,
  PAGINATION_CHANGE,
  loadSuccess,
  loadError,
  load,
} from './actions';

const loadTagsHistory = (action, state, { tagsHistoryService }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => tagsHistoryService
    .getTagsHistoryByPageNum(action$.deviceId, action$.pageNum, action$.tagsData, action$.limit)
    .pipe(
      map(loadSuccess),
      takeUntil(action.pipe(ofType(CLEAR))),
      catchError(createErrorStream(action$, loadError)),
    )),
);

const loadMoreTags = action => action.pipe(
  ofType(PAGINATION_CHANGE),
  map(load),
);

export default combineEpics(
  loadTagsHistory,
  loadMoreTags,
);
